import { render } from "./alertBox.vue?vue&type=template&id=3343f9de&scoped=true"
import script from "./alertBox.vue?vue&type=script&lang=js"
export * from "./alertBox.vue?vue&type=script&lang=js"

import "./alertBox.vue?vue&type=style&index=0&id=3343f9de&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sato\\Desktop\\learncanvas\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3343f9de"]])

export default __exports__